import { some } from 'lodash';

export const SearchFilter = {
  bindings: {
    list: '<',
    title: '@',
    type: '@',
    onClick: '&',
  },

  template: `
    <section class="search-filters p-2 border border-bottom">
      <header class="d-flex justify-content-between align-items-center pointer"
        data-toggle="collapse"
        data-target="#{{ $ctrl.title | kebabCase }}"
        ng-click="isOpen = !isOpen">
        {{ $ctrl.title }}
        <i class="fa fa-lg"
          ng-class="{ 'fa-angle-up': isOpen, 'fa-angle-down': !isOpen}">
        </i>
      </header>
      <ul class="collapse list-inline mt-2 mb-0"
        ng-class="{ 'show': $ctrl.show }"
        id="{{ $ctrl.title | kebabCase }}">
        <li class="list-inline-item d-flex"
          ng-repeat="item in $ctrl.list track by $index">
          <label class="pointer"
            ng-class="{ 'checked' : item.checked  }">
            <input class="d-none"
              type="radio"
              name="{{ $ctrl.title | kebabCase }}"
              ng-checked="item.checked"
              ng-click="$ctrl.onClick({ item: item, type: $ctrl.type, list: $ctrl.list })">
            <i class="fa"
              ng-class="{
                'fa-circle-o': $ctrl.type == 'radio' && !item.checked,
                'fa-dot-circle-o': $ctrl.type == 'radio' && item.checked,
                'fa-square-o': $ctrl.type == 'checkbox' && !item.checked,
                'fa-check-square': $ctrl.type == 'checkbox' && item.checked,
                'text-gray-400': !item.checked,
                'text-green': item.checked
              }"></i>
            <span>{{ item.name }}</span>
          </label>
        </li>
      </ul>
    </section>`,

  controller() {
    return {
      $onChanges(changes) {
        this.show = some(changes.list.currentValue, 'checked');
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Search/SearchFilter.js